import { create } from 'zustand'

const useDepartmentStore = create((set) => ({
  departments: [],
  fetchDepartments: async () => {
    try {
      const response = await fetch('/api/departments/get');
      if (!response.ok) {
        throw new Error('Failed to fetch departments');
      }
      const data = await response.json();
      set({ departments: data.result});
    } catch (error) {
      console.error('Error fetching departments:', error);
      set({ departments: [] });
    }
  },
}));

export default useDepartmentStore